import type { DutyToolListItem, ToolKind } from '@/features/tools/types'

export const AUTHENTICATE_CALLER_DISPLAY_NAME = 'Authentication'

export function toolDisplayName(tool: {
  kind: ToolKind
  name: string
}): string {
  if (tool.kind === 'calcom') {
    return `Cal.com - ${tool.name.replace(/^Cal\.com\s*[-–—]\s*/i, '')}`
  }
  return tool.kind === 'authenticate_caller'
    ? AUTHENTICATE_CALLER_DISPLAY_NAME
    : tool.name
}

export function toolSupportsDavid(kind: ToolKind): boolean {
  switch (kind) {
    case 'generic_webhook':
    case 'signing_documents':
    case 'get_data':
      return true
    case 'send_text':
    case 'authenticate_caller':
    case 'confirm_appointment':
    case 'benefitscal_resume_questionnaire':
    case 'benefitscal_save_answers':
    case 'configured_duty_handoff':
    case 'transfer_call':
    case 'calcom': // David operation discovery is a separate follow-up.
      return false
  }
}

export function dutyToolIsKind<Kind extends ToolKind>(
  tool: DutyToolListItem,
  kind: Kind
): tool is Extract<DutyToolListItem, { tool: { kind: Kind } }> {
  return tool.tool.kind === kind
}
